import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

import { AuthProvider } from '../../../services/auth.provider';
import { Oneperweek } from '../../../services/oneperweek';
import { Article } from '../../../models/article.model';
import { PopUp } from '../../../models/popup.model';

@Component({
  selector: 'app-search-card',
  templateUrl: 'search-card.html',
  styleUrls: ['search-card.scss']
})
export class SearchCardComponent {
  @Input() articles: Array<Article>;
  @Input() i: number;
  @Input() article: Article;
  @Input() video: { [key: number]: boolean } = {};
  @Input() themeClass: string;
  @Output() public activatePopUp: EventEmitter<boolean> = new EventEmitter();
  @Output() public showOnePerWeek: EventEmitter<PopUp> = new EventEmitter();
  private popup: PopUp = new PopUp();

  constructor(public auth: AuthProvider, private router: Router, private oneperweek: Oneperweek) { }

  navigateToDetailSearch( slug: string, type: string, free: boolean, id: string ) {
    this.oneperweek.checkOnePerWeek(id, type);
    if (this.oneperweek.pass || free === true) {
      if (type === 'article') {
        this.router.navigate(['article', slug]);
      }

      if (type === 'factsheet') {
        this.router.navigate(['exposes-detail', slug]);
      }

      if (type === 'dossier') {
        this.router.navigate(['dossiers-actualite', slug]);
      }
    } else {
      this.popup.type = 'five';
      this.popup.data = this.oneperweek.remainingDays.toString();
      this.activatePopUp.emit(true);
      this.showOnePerWeek.emit(this.popup);
    }
  }
}
